export const dark = {
  autofill: '#5D5881',
  background: {
    default: '#1D1E1F',
    paper: '#2E2F31',
  },
  checkbox: {
    default: '#FFFFFF',
  },
  divider: '#252728',
  error: '#C22D74',
  font: {
    button: '#202124',
    default: '#FCFCFC',
    gray: '#9E9D9D',
    textButton: '#FFFFFF',
    textDisabled: '#FCFCFC',
  },
  gray: {
    default: '#202124',
    disabled: 'rgba(32, 33, 36, 0.6)',
  },
  input: {
    border: '#9d9d9d',
    default: '#25262A',
    disabled: '#393939',
    disabledBackground: '#292A2D',
    disabledText: '#9D9D9D',
    error: '#8C2054',
    text: '#FCFCFC',
    textHover: '#616161',
  },
  paperBorder: '#252728',
  primary: '#000000',
  secondary: '#005058',
  warning: '#F38F1C',
  theme: 'dark',
}
export const light = {
  autofill: '#f4f6c5',
  background: {
    default: '#FFFFFF',
    paper: '#FFFFFF',
  },
  checkbox: {
    default: '#616161',
  },
  divider: '#d8d8d8',
  error: '#C22D74',
  font: {
    button: '#FFFFFF',
    default: '#000',
    gray: '#616161',
    textButton: '#06847B',
    textDisabled: '#616161',
  },
  gray: {
    default: '#C8C8C8',
    disabled: 'rgba(216, 216, 216, 0.3)',
  },
  input: {
    border: '#BDBDBD',
    default: '#FFFFFF',
    disabled: '#EAEAEA',
    disabledBackground: '#F4F4F4',
    disabledText: '#9D9D9D',
    error: '#8C2054',
    text: '#000',
    textHover: '#616161',
  },
  paperBorder: '#d8d8d8',
  primary: '#000000',
  secondary: '#005058',
  warning: '#F38F1C',
  theme: 'light',
}
